
/**
 * Module dependencies.
 */

import {
  fetchCollections,
  paginationLimit
} from 'src/api/app/collections/fetch-collections';

import { fetchPage } from 'src/api/app/pages/fetch-page';
import { getApiPageSlugByLocale } from 'src/core/utils/routes';
import CollectionsPage, { Props } from 'src/components/pages/collections';
import React, { ReactElement } from 'react';
import isEmpty from 'lodash/isEmpty';

/**
 * `Collections` page.
 */

const Collections = (props: Props): ReactElement => <CollectionsPage {...props} />;

/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, query }) {
  const slug = getApiPageSlugByLocale('collections', locale);
  const pageData = await fetchPage({
    hasPreview: query?.preview,
    locale,
    slug
  });

  if (!pageData) {
    return {
      notFound: true
    };
  }

  const collections = await fetchCollections({
    locale,
    params: {
      limit: paginationLimit,
      page: 1,
      sort: isEmpty(query) ? 'sort_order' : 'name',
      ...query
    }
  });

  return {
    props: {
      collections: {
        pageParams: [1],
        pages: [collections ?? []]
      },
      data: pageData,
      slug
    }
  };
}

/**
 * Export `Collections` page.
 */

export default Collections;
